var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-truncate"},[_c('img',{staticClass:"icon icon-sm",attrs:{"src":_vm.icon}}),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }